import { SURVEY_FLOW } from './types';


export const setSurveyFlow = (surveyFlow) => {
    return {
        type: SURVEY_FLOW.SET_SURVEY_FLOW,
        surveyFlow: surveyFlow
    }
}